export default "__VITE_ASSET__ilaq8xg3__"